import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  title="Tax Invoice";
  constructor() { }

  ngOnInit() {
  }

  // faqs(){
  //      pageref();
  // }
}



// WEBPACK FOOTER //
// ./src/app/home/faq/faq.component.ts